import React from 'react'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@material-ui/core'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import dayjs from 'dayjs'
import CustomDatePicker from 'src/components/common/custom-components/CustomDatePicker'
import { Button } from '@mui/material'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#B92250',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '9px',
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}))

const TableView = ({ data, setData, setSelectedPersons }) => {
  const classes = useStyles()
  const handleDateChange = (date, empId) => {
    const updatedData = data?.filter((each) => {
      return each?.id === empId
    })
    setSelectedPersons((prevStat) => {
      const recordIndex = prevStat?.findIndex(
        (record) => record?.id === updatedData?.[0]?.id
      )
      const updatedState = [...prevStat]
      updatedState[recordIndex] = {
        ...updatedState?.[recordIndex],
        dateOfLeaving: date?.target?.value,
      }
      return updatedState
    })

    setData((prevState) => {
      const recordIndex = prevState?.findIndex(
        (record) => record?.memberId === updatedData?.[0]?.id
      )

      if (recordIndex !== -1) {
        const updatedState = [...prevState]
        updatedState[recordIndex].dateOfLeaving = date?.target?.value
        return updatedState
      } else {
        return [
          ...prevState,
          {
            memberId: updatedData?.[0]?.id,
            dateOfLeaving: date?.target?.value,
          },
        ]
      }
    })
  }

  const handleDeselect = (empId, id) => {
    setSelectedPersons((prevState) =>
      prevState?.filter((employee) => employee?.empId !== empId)
    )
    setData((prevState) =>
      prevState?.filter((employee) => employee?.memberId !== id)
    )
  }

  return (
    <>
      <TableContainer
        className={`${classes.tableContainer} ${
          data?.length > 2
            ? classes.tableContainerScrollable
            : classes.tableContainerNonScrollable
        }`}
      >
        <Table aria-label='customized table' stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell align='center'>Emp Name</StyledTableCell>
              <StyledTableCell align='center'>Emp Id</StyledTableCell>
              <StyledTableCell align='center'>Date of Leaving</StyledTableCell>
              <StyledTableCell align='center'>Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((item) => (
              <StyledTableRow key={item?.empId}>
                <StyledTableCell
                  component='th'
                  scope='row'
                  align='center'
                  className={
                    item?.policies?.length === 0
                      ? classes.opacityLow
                      : classes.opacityHigh
                  }
                >
                  {item?.firstName}
                </StyledTableCell>
                <StyledTableCell
                  align='center'
                  className={
                    item?.policies?.length === 0
                      ? classes.opacityLow
                      : classes.opacityHigh
                  }
                >
                  {item?.empId}
                </StyledTableCell>
                <StyledTableCell
                  align='center'
                  className={
                    item?.policies?.length === 0
                      ? classes.opacityLow
                      : classes.opacityHigh
                  }
                >
                  <CustomDatePicker
                    name={'DateOfLeaving'}
                    onChange={(date) => handleDateChange(date, item?.id)}
                    key={item?.id}
                    value={
                      // sortedData?.length === data?.length
                      //   ? sortedData?.[index]?.dateOfLeaving
                      //     ? dayjs(sortedData?.[index]?.dateOfLeaving)
                      //     : null
                      //   :
                      item?.dateOfLeaving ? dayjs(item?.dateOfLeaving) : null
                    }
                    placeholder={'DD/MM/YYYY'}
                    className={classes.formFieldDate}
                    disabled={true}
                  />
                  {item?.policies?.length === 0 && (
                    <span className={classes.error}>
                      {' '}
                      Please deselect the person to proceed further as this
                      person is not in any policy
                    </span>
                  )}
                </StyledTableCell>
                <StyledTableCell align='center'>
                  <Button
                    onClick={() => {
                      handleDeselect(item?.empId, item?.id)
                    }}
                    className={classes.nextBtn}
                  >
                    Deselect
                  </Button>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default TableView

const useStyles = makeStyles({
  formFieldDate: {
    width: '40%',
    fontSize: '8px',
    '& .MuiOutlinedInput-input': {
      paddingTop: '10px !important',
      paddingBottom: '10px !important',
      textIndent: '8px',
    },
    '& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled': {
      '-webkit-text-fill-color': 'black',
    },
  },
  nextBtn: {
    marginLeft: 'auto !important',
    color: '#fff !important',
    borderColor: '#B92250 !important',
    backgroundColor: '#B92250 !important',
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.5) !important',
      borderColor: 'rgba(185, 34, 80, 0.5) !important',
      backgroundColor: 'rgba(185, 34, 80, 0.5) !important',
    },
  },
  error: {
    color: 'red',
  },
  opacityLow: {
    opacity: 0.5,
  },
  opacityHigh: {
    opacity: 1,
  },
  tableContainer: {
    borderRadius: '5px',
    border: '1px solid #B92250',
  },
  tableContainerScrollable: {
    maxHeight: 240,
    overflowY: 'scroll',
  },
  tableContainerNonScrollable: {
    maxHeight: 'none',
    overflowY: 'none',
  },
})
